import { SYSTEM_VARIABLE_CATALOG, getLocalizedCategory, getLocalizedLabel, getLocalizedSubcategory, isAnyCatalogLabel, normalizeVariableLabel } from '~/components/AgreementStudioPage/TemplateVariables/TemplateVariables.utils';
export const CATEGORY_ORDER = [
    'This notification',
    'Primary contact',
    'Client',
    'My Business',
    'Agreement'
];
const NOTIFICATION_ONLY_CATEGORIES = [
    'This notification',
    'Primary contact'
];
function groupSystemVariablesByCategory(filteredSystemVars) {
    const grouped = new Map();
    for (const category of CATEGORY_ORDER){
        const entries = filteredSystemVars.filter((v)=>v.category === category);
        if (entries.length > 0) {
            grouped.set(category, entries);
        }
    }
    return grouped;
}
export function buildSelectableItems(customVariables, excludeLabels, options) {
    const { allowedSystemKeys, texts } = options;
    const filteredSystem = SYSTEM_VARIABLE_CATALOG.filter((v)=>!excludeLabels.has(normalizeVariableLabel(v.label))).filter((v)=>{
        if (allowedSystemKeys != null) return allowedSystemKeys.has(v.key);
        return !NOTIFICATION_ONLY_CATEGORIES.includes(v.category);
    });
    const grouped = groupSystemVariablesByCategory(filteredSystem);
    const items = [];
    for (const [category, entries] of grouped){
        for (const entry of entries){
            const subcategory = 'subcategory' in entry ? entry.subcategory : undefined;
            items.push({
                type: 'variable',
                label: entry.label,
                displayLabel: getLocalizedLabel(entry.labelKey, texts),
                category,
                displayCategory: getLocalizedCategory(category, texts),
                subcategory,
                displaySubcategory: subcategory != null ? getLocalizedSubcategory(subcategory, texts) : subcategory
            });
        }
    }
    for (const label of customVariables){
        const displayCategory = texts.categories.custom();
        items.push({
            type: 'variable',
            label,
            displayLabel: label,
            category: 'Custom',
            displayCategory
        });
    }
    return items;
}
export function canCreateVariable(searchText, customVariables) {
    const trimmed = searchText.trim();
    if (trimmed.length === 0) return false;
    return !isAnyCatalogLabel(trimmed) && !customVariables.some((v)=>normalizeVariableLabel(v) === normalizeVariableLabel(trimmed));
}
export function getCategoryForItem(items, index) {
    var _item_displaySubcategory, _prevItem_displaySubcategory;
    const item = items[index];
    const currentHeader = (_item_displaySubcategory = item.displaySubcategory) !== null && _item_displaySubcategory !== void 0 ? _item_displaySubcategory : item.displayCategory;
    if (index === 0) {
        return currentHeader;
    }
    const prevItem = items[index - 1];
    const prevHeader = (_prevItem_displaySubcategory = prevItem.displaySubcategory) !== null && _prevItem_displaySubcategory !== void 0 ? _prevItem_displaySubcategory : prevItem.displayCategory;
    if (item.category !== prevItem.category || currentHeader !== prevHeader) {
        return currentHeader;
    }
    return null;
}
